import * as React from "react";
import { EventCardDetailsInfoAmericanDesktop } from "../EventCardDetailsInfoAmericanDesktop";
import { GameStateWrapper } from "../GameStateWrapper";
import { IconsWrapperAmerican } from "../IconsWrapperAmerican";
export const EventCardDetailsAmericanDesktop = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(GameStateWrapper, { details: props.details, componentPrefix: props.componentPrefix }),
        React.createElement(EventCardDetailsInfoAmericanDesktop, { details: props.details, componentPrefix: props.componentPrefix }),
        React.createElement(IconsWrapperAmerican, { details: props.details, componentPrefix: props.componentPrefix })));
};
//# sourceMappingURL=EventCardDetailsAmericanDesktop.js.map